import map from "../assets/phaser-trade-quarter/trade-waterfront-island.webp";
import ocean from "../assets/phaser-trade-quarter/trade-waterfront-ocean.webp";
import skiff from "../assets/phaser-trade-quarter/trade-waterfront-skiff.webp";
import panorama from "../assets/phaser-trade-quarter/trade-quarter-waterfront.webp";
import crystal from "../assets/phaser-hq/diamond-base.png";
import plaque from "../assets/quarter-map-layers/name-plaque.png";
import type { MarketTab } from "../domain/market";
import type { Locale } from "../domain/types";

export const TRADE_QUARTER_ART = { map, ocean, skiff, crystal, plaque } as const;
// Profile/page cameras share the same architecture as the fitted waterfront map.
export const TRADE_PANORAMA_ART = { map: panorama, width: 941, height: 1672 } as const;
/** Cameras on the original connected district, not replacement building sprites. */
export const TRADE_PANORAMAS = {
  preview: { x: .51, y: .407, width: 1, height: .34, lightX: .66, lightY: .42 },
  exchange: { x: .27, y: .386, width: .59, height: .34, lightX: .33, lightY: .38 },
  quests: { x: .72, y: .406, width: .58, height: .34, lightX: .69, lightY: .40 },
  liquidity: { x: .29, y: .655, width: .62, height: .34, lightX: .30, lightY: .42 },
  archive: { x: .72, y: .66, width: .57, height: .35, lightX: .69, lightY: .44 },
} as const;
export const TRADE_SCENE_KINDS = { swap: "exchange", tasks: "quests", liquidity: "liquidity", history: "archive" } as const;
/** Coordinates measured against the more spacious composition, not guessed screen pixels. */
export const TRADE_QUARTER = {
  width: 941, height: 1672,
  // Anchor to the platform's BACK RIM, not its centre: visible air under the gem.
  crystal: { x: .5, y: .239 },
  motion: { floatPeriodMs: 4600, floatAmplitude: .045, glintPeriodMs: 6200 },
  buildings: [
    { id: "swap", x: .268, y: .37, width: .28, height: .218, labelY: .483,
      label: { ru: "Биржа", en: "Exchange" }, title: { ru: "Биржа королевства", en: "Kingdom Exchange" },
      hint: { ru: "Покупка и продажа токенов", en: "Buy and sell tokens" } },
    { id: "tasks", x: .755, y: .388, width: .29, height: .22, labelY: .494,
      label: { ru: "Дом поручений", en: "Quest House" }, title: { ru: "Дом поручений", en: "Quest House" },
      hint: { ru: "Торговые задачи и награды", en: "Trading quests and rewards" } },
    { id: "liquidity", x: .28, y: .63, width: .29, height: .19, labelY: .714,
      label: { ru: "Ликвидность", en: "Liquidity" }, title: { ru: "Мастерская ликвидности", en: "Liquidity Workshop" },
      hint: { ru: "GRAM и ваши награды игры", en: "GRAM and your game rewards" } },
    { id: "history", x: .768, y: .636, width: .29, height: .26, labelY: .746,
      label: { ru: "Архив сделок", en: "Trade Archive" }, title: { ru: "Архив сделок", en: "Trade Archive" },
      hint: { ru: "Обмены и ваши LP-позиции", en: "Your swaps and LP positions" } },
  ] satisfies { id: MarketTab; x: number; y: number; width: number; height: number; labelY: number;
    label: Record<Locale, string>; title: Record<Locale, string>; hint: Record<Locale, string> }[],
} as const;

export function tradeQuarterCopy(locale: Locale) {
  return locale === "ru" ? { title: "Торговый квартал", world: "DIAMOND KINGDOM", home: "К бриллианту", back: "На карту", choose: "Выберите здание", more: "Показать здания ниже", top: "К началу карты", profile: "Открыть карту", intro: "Биржа, поручения и ликвидность" }
    : { title: "Market Quarter", world: "DIAMOND KINGDOM", home: "Back to diamond", back: "Map", choose: "Choose a building", more: "Show buildings below", top: "Back to map top", profile: "Explore the map", intro: "Exchange, quests and liquidity" };
}
